import React from 'react';

export default class Tabs extends React.Component
{
    render()
    {
        return <div className='border-b border-gray-300'>
            <nav className="-mb-px flex space-x-8">
                { this.props.children }
            </nav>
        </div>;
    }
}
